import {
  UpdateSecretsRequest,
  UpdateSecretsResponse,
} from "@protos/secrets/v1/secrets";

import { authPut } from "../auth/auth";

export const updateSecretsFindings = async (
  body: UpdateSecretsRequest,
  query: URLSearchParams
): Promise<UpdateSecretsResponse> => {
  const { deploymentId } = body;
  const q = query.toString();
  const url = `/api/secrets/deployments/${deploymentId}/findings?${q}`;
  const response = await authPut<UpdateSecretsRequest, UpdateSecretsResponse>(
    url,
    body
  );
  return response;
};
